<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18Voo1u/tc-custom/9781501196591.jpg?1730489809124" alt="This image is the cover for the book National Outdoor Leadership School's Wilderness Guide"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">National Outdoor Leadership School's Wilderness Guide
      </h1>
      <p class="bookDescription body article font2">
        <b>The classic backpacker’s handbook—revised and updated—providing expert guidelines for anyone who loves the outdoors.</b><br/><br/>The <i>Wilderness Guide</i> brings the savvy of the world's most famous and respected outdoor organization to everyone—from the sixteen million backpacking Americans to the more than 265 million people, tenderfeet and trail-hardened hikers, who visit our national parks annually. It covers:<br/><br/>-Selecting equipment—including discussions of the advantages and disadvantages of products such as the internal frame pack, lighter-weight boots, and freestanding tents<br/><br/>-The latest “leave no trace” camping techniques<br/><br/>-Traveling safely and sensibly—including vital information on maps, compasses, and tips on crossing difficult terrain<br/><br/>-Backcountry cooking, with tips on building fires and tricks for making gourmet meals<br/><br/>-Search-and-rescue techniques, including how to organize a self-sufficient search group and when to call in professional rescue teams<br/><br/>Illustrated throughout with instructional drawings and photos and featuring lists of equipment, the <i>Wilderness Guide</i> is a must-have for anyone planning to explore the great outdoors.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mark Harvey
      </h2>
      
      <p class="authorDescription body article">The National Outdoor Leadership School conducts outdoor adventure programs at eight branches throughout the world; its headquarters are in the foothills of Wind River Range in Lander, Wyoming.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Touchstone
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4104915a